import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { CustomVizId } from 'libs/end-to-end/src/custom-viz/CustomVizId';
import { MyOrganizationExternalStreamlitAppEntitlement } from 'libs/end-to-end/src/external-streamlit-apps';

export const getFocusAreaDefinitionForMyObservation = ({
  focusArea,
  myObservation,
}: {
  myObservation: MyObservation | null;
  focusArea: string;
}) => {
  return myObservation?.focusAreas?.find((fa) => fa.focusArea === focusArea);
};

export const getPreferredPerformanceMetricForMyObservation = (
  myObservation: MyObservation | null,
) => {
  return (
    myObservation?.focusAreas
      .find((fa) => fa.focusArea === 'Performance')
      ?.metrics.find((m) => m.isPreferred) ?? null
  );
};

export const determinePossiblePrototypeStreamlitAppsForMyObservation = ({
  customVizId,
  myObservation,
}: {
  customVizId: CustomVizId | null;
  myObservation: MyObservation | null;
}): MyOrganizationExternalStreamlitAppEntitlement[] => {
  if (customVizId === null) {
    return [];
  }

  // We allow all vizes other than external streamlit to be prototyped over,
  // so this check returns an empty array to prevent the user from defining this on the standalone (non-prototype) version.
  if (customVizId === 'externalStreamlit') {
    return [];
  }

  if (!myObservation) {
    return [];
  }

  return myObservation.streamlitAppEntitlements
    .filter(
      (appEntitlement) => appEntitlement.prototypeCustomVizId === customVizId,
    )
    .map((appEntitlement) => {
      return appEntitlement;
    });
};
